import {css} from 'lit';
export const styles = css`:host {
  display: flex;
  align-items: center;
  color: var(--dark-text-secondary);
  font-size: var(--bu-font-size-xs);
  font-weight: 500;
}

:host([likesUrl]) {
  cursor: pointer;
}

.icon {
  width: 16px;
  height: 16px;
  margin-right: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: var(--secondary);
  color: var(--contrast-light);
  font-size: 8px;
}
`;
export default styles;
